import jpegxlFactory from '@cornerstonejs/codec-libjxl/decodewasmjs';
const jpegxlWasm = new URL('@cornerstonejs/codec-libjxl/decodewasm', import.meta.url);
import getPixelData from './getPixelData.js';
import { resolveWasmUrl, setWasmBasePathFromConfig } from '../wasmBasePath.js';
const local = {
    codec: undefined,
    decoder: undefined,
    decodeConfig: {},
};
function getExceptionMessage(exception) {
    return typeof exception === 'number' && local.codec?.getExceptionMessage
        ? local.codec.getExceptionMessage(exception)
        : exception;
}
export function initialize(decodeConfig) {
    local.decodeConfig = decodeConfig;
    setWasmBasePathFromConfig(decodeConfig);
    if (local.codec) {
        return Promise.resolve();
    }
    const jpegxlModule = jpegxlFactory({
        locateFile: (f) => {
            if (f.endsWith('.wasm')) {
                return resolveWasmUrl('jpegxlwasm_decode.wasm', jpegxlWasm);
            }
            return f;
        },
    });
    return new Promise((resolve, reject) => {
        jpegxlModule.then((instance) => {
            local.codec = instance;
            local.decoder = new instance.JpegXLDecoder();
            resolve();
        }, reject);
    });
}
async function decodeAsync(compressedImageFrame, imageInfo) {
    try {
        await initialize();
        const decoder = local.decoder;
        const encodedBufferInWASM = decoder.getEncodedBuffer(compressedImageFrame.length);
        encodedBufferInWASM.set(compressedImageFrame);
        decoder.decode();
        const frameInfo = decoder.getFrameInfo();
        const decodedPixelsInWASM = decoder.getDecodedBuffer();
        const encodedImageInfo = {
            columns: frameInfo.width,
            rows: frameInfo.height,
            bitsPerPixel: frameInfo.bitsPerSample,
            signed: imageInfo.signed,
            bytesPerPixel: imageInfo.bytesPerPixel,
            componentsPerPixel: frameInfo.componentCount,
        };
        const pixelData = getPixelData(frameInfo, decodedPixelsInWASM, imageInfo.signed);
        const encodeOptions = {
            frameInfo,
        };
        return {
            ...imageInfo,
            pixelData,
            imageInfo: encodedImageInfo,
            encodeOptions,
            ...encodeOptions,
            ...encodedImageInfo,
        };
    }
    catch (error) {
        throw getExceptionMessage(error);
    }
}
export default decodeAsync;
